import { render, staticRenderFns } from "./FlowForm.vue?vue&type=template&id=2e72f84c&"
import script from "./FlowForm.vue?vue&type=script&lang=js&"
export * from "./FlowForm.vue?vue&type=script&lang=js&"
import style0 from "./FlowForm.vue?vue&type=style&index=0&id=2e72f84c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports